import { render, staticRenderFns } from "./SubService.vue?vue&type=template&id=088233eb&scoped=true&"
import script from "./SubService.vue?vue&type=script&lang=js&"
export * from "./SubService.vue?vue&type=script&lang=js&"
import style0 from "./SubService.vue?vue&type=style&index=0&id=088233eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088233eb",
  null
  
)

export default component.exports